﻿export const orderId = (state) => {

    return state.order.orderId;
}

export const orderPersonName = (state) => {
    if (state.order.orderer)
        return state.order.orderer.person.name.firstName + " " + state.order.orderer.person.name.lastName;
    else return "";
}

export const orderPersonAddressStreet = (state) => {
    if (state.order.orderer) {
        let streetAddress = state.order.orderer.streetAddress.streetName + " ";
        streetAddress += state.order.orderer.streetAddress.streetNumber;
        streetAddress += state.order.orderer.streetAddress.streetNumberSuffix ? state.order.orderer.streetAddress.streetNumberSuffix : '';
        streetAddress += ' ';
        streetAddress += state.order.orderer.streetAddress.floorNumber ? state.order.orderer.streetAddress.floorNumber : '';
        streetAddress += ' ';
        streetAddress += state.order.orderer.streetAddress.direction ? state.order.orderer.streetAddress.direction : '';
        streetAddress += ' ';
        streetAddress += state.order.orderer.streetAddress.doorNumber ? state.order.orderer.streetAddress.doorNumber : '';
        return streetAddress;
    }
    else {
        return "";
    }
}

export const orderPersonAddressCity = (state) => {
    if (state.order.orderer)
        return state.order.orderer.streetAddress.zipCode + " " + state.order.orderer.streetAddress.city
    else return "";
}

export const orderTotalPrice = (state) => {
    const subscriptionAgreementItems = state.creditAgreement.subscriptionAgreementItems;
    if (!subscriptionAgreementItems) {
        return 0;
    }

    let result = 0;
    for (let i = 0; i < subscriptionAgreementItems.length; i++) {
        const subscriptionAgreementItem = subscriptionAgreementItems[i];

        result += getTotalPricePerSubscription(subscriptionAgreementItem);
    }

    return result + " kr";
}

function getTotalPricePerSubscription(subscriptionAgreementItem) {
    if (!subscriptionAgreementItem) {
        return 0;
    }

    let sum = 0;

    for (let i = 0; i < subscriptionAgreementItem.hardwareItems.length; i++) {
        const hardwareItem = subscriptionAgreementItem.hardwareItems[i];

        sum += hardwareItem.price - hardwareItem.discount;
    }

    return sum;
}

export const currency = (state) => {
    if (state.order.orderItems && state.order.orderItems[0].hardwarePayment) {
        return state.order.orderItems[0].hardwarePayment.totalPayment.currency
    }
    else {
        return "kr";
    }
}

export const creditPaymentSelected = (state) => {
    if (!state.order.useNewDiva) {
        if (state.preAuth.availableAmount >= state.creditAgreement.totalCredit) {
            return false;
        }
        return showCreditAgreementDetails(state) && installmentsSelected(state);
    }
    else {
        if (state.joiceCreditCheck.creditAccountCurrentAvailableAmount >= state.creditAgreement.totalCredit) {
            return false;
        }
        return showCreditAgreementDetails(state) && installmentsSelected(state);
    }
}

export const collectPBSinfo = (state) => {
    if (!state.order.useNewDiva) {
        if (state.paymentMethod.toLowerCase() === "pbs" &&
            state.order.creditCheckDetails.externalCreditCheck.customerStatus === "NEW" &&
            state.creditEvaluation.creditCheckResult.approved) {
            return true;
        }
    }
    else if (state.paymentMethod.toLowerCase() === "pbs" && state.order.creditCheckDetails.externalCreditCheck.customerStatus === "NEW") {
        return true;
    }
    return false;
}

export const showCreditAgreementDetails = (state) => {
    if (!state.order.useNewDiva) {
        for (let i = 0; i < state.creditAgreement.subscriptionAgreementItems.length; i++) {
            if (state.creditAgreement.subscriptionAgreementItems[i].paymentBy === "credit") {
                return true;
            }
        }
    }
    else {
        if (state.order.paymentBy.toLowerCase() === "credit") {
            return true;
        }
    }
    return false;
}

export const installmentsSelected = (state) => {
    if (!state.order.useNewDiva) {
        for (let i = 0; i < state.creditAgreement.subscriptionAgreementItems.length; i++) {
            if (state.creditAgreement.subscriptionAgreementItems[i].paymentBy === "credit" && state.creditAgreement.subscriptionAgreementItems[i].numberOfInstallments === 0) {
                return false;
            }
        }
    }
    else {
        if (state.order.paymentBy.toLowerCase() === "credit" && state.creditAgreement.numberOfInstallments === 0) {
            return false;
        }
    }
    return true;
}

export const isPBSInfoValid = (state) => {
    const pbs = state.pbsInformation;
    let status = { 'valid': true, 'message': '' };
    if (pbs.accountNumber.trim().length > 0 && pbs.regNumber.trim().length > 0 && pbs.bankName.trim().length > 0) {
        if (pbs.accountNumber.search(/^([0-9]{7,10})$/) < 0) {
            status.valid = false;
            status.message = 'The entered account number is not valid';
        }
        if (pbs.regNumber.search(/^([0-9]{4})$/) < 0) {
            status.valid = false;
            status.message = 'The entered reg. number is not valid';
        }
        if (pbs.bankName.length === 0) {
            status.valid = false;
            status.message = 'Bank name is required';
        }
    }
    else {
        status.valid = false;
        status.message = "All fields must be filled out"
    }
    return status;
}

export const teliaContracts = (state) => {
    return state.contracts.teliaContracts;
}

export const tfContracts = (state) => {
    return state.contracts.tfContracts;
}

export const pageDetails = (state) => {
    return state.pageDetails;
}

export const contractsSignedInfo = (state) => {
    return state.contracts.contractsSigned;
}

export const hasAnyContract = (state) => {
    return state.contracts.hasAnyContract;
}

export const hasAnyTeliaContract = (state) => {
    return state.contracts.hasAnyTeliaContract;
}

export const areDiscountAmountsValid = (state) => {
    const subscriptionAgreementItems = state.creditAgreement.subscriptionAgreementItems;

    // For each subscriptionAgreementItem
    for (let i = 0; i < subscriptionAgreementItems.length; i++) {
        let subscriptionAgreementItem = subscriptionAgreementItems[i];

        // For each hardwareItem in subscriptionAgreementItem
        for (let j = 0; j < subscriptionAgreementItem.hardwareItems.length; j++) {
            let hardwareItem = subscriptionAgreementItem.hardwareItems[j];

            let discountAmount = hardwareItem.discount;
            let originalPrice = hardwareItem.price;

            // Check price with discount
            if (discountAmount >= originalPrice) {
                return false;
            }
        }
    }
    return true;
}

export const areDiscountAmountsValidByOrder = (state) => {
    const subscriptionAgreementItems = state.creditAgreement.subscriptionAgreementItems;
    let discountAmount = state.order.discount;
    let originalPrice = 0;
    for (let item = 0; item < subscriptionAgreementItems.length; item++) {
        let subscriptionAgreementItem = subscriptionAgreementItems[item];

        for (let i = 0; i < subscriptionAgreementItem.hardwareItems.length; i++) {
            originalPrice += subscriptionAgreementItem.hardwareItems[i].price;
        }
    }
    // Check price with discount
    if (discountAmount >= originalPrice) {
        return false;
    }
    return true;
}